<template>
    <div class="w-full mx-4 md:mx-0 md:px-20 py-10 pb-0 bg-off-white sticky top-[80px] z-10">
        <div class="md:px-10">
            <div class="flex flex-col md:flex-row items-baseline text-dark-deep-blue/60">
                <div class="flex items-center">
                    <AppropriatenessScorePillComponent :score="submission.submission.appropriateness_score" class="mr-3"
                                                       labelBottom />
                    <h2 class="!normal-case text-xl">
                        {{ submission.personal_details.title }}
                        <span class="text-dark-deep-blue">
                            <span
                                v-if="submission.personal_details.first_name != undefined && submission.personal_details.last_name != undefined">
                                {{ submission.personal_details.first_name + " " + submission.personal_details.last_name
                                }}
                            </span>
                            <span v-else>
                                <!-- Fallback to email address if there's no name to use -->
                                {{ submission.email }}
                            </span>
                        </span>
                    </h2>
                </div>
                <div class="md:ml-8">
                    id:
                    <strong>{{ submission.id }}</strong>
                </div>
                <div class="flex items-center md:ml-8">
                    Submission status:
                    <StatusBadgeComponent :status="submissionStatus" class="ml-2" />
                </div>
                <div class="md:ml-8 mt-3 md:mt-0 flex">acc no:
                    <InputComponent class="ml-2" :disabled="false" :hideWhenEmpty="false" v-model="customAccountNumber"
                                    @change="doUpdateUser" />
                </div>
            </div>
            <div class="flex flex-col md:flex-row md:items-center text-dark-deep-blue/60 mt-4">
                Application status:
                <div class="flex flex-wrap my-auto gap-3 md:gap-0 md:items-center mt-4 md:mt-0">
                    <ButtonStatusComponent
                        class="md:ml-3"
                        status="Under Review"
                        @click="doUpdateSubmissionStatus({ status: 'Under Review' })"
                        :active="!!submission.submission.status"
                    />
                    <ButtonStatusComponent
                        class="md:ml-3"
                        status="First Approval"
                        @click="showHideApprovalModal({ show: true, approvalType: 'First Approval' })"
                        :disabled="
                        !!isButtonDisabled('First Approval') && submission.submission.status !== 'First Approval' && submission.submission.status !== 'Approved'
                    "
                        :active="submission.submission.status === 'First Approval' || submission.submission.status === 'Approved'"
                    />
                    <ButtonStatusComponent
                        class="md:ml-3"
                        status="Second Approval"
                        @click="showHideApprovalModal({ show: true, approvalType: 'Approved' })"
                        :disabled="
                        !!isButtonDisabled('Second Approval') && submission.submission.status !== 'Approved'
                    "
                        :active="submission.submission.status === 'Approved'"
                    />
                    <ButtonStatusComponent
                        class="md:ml-3"
                        status="Reject"
                        @click="showHideApprovalModal({ show: true, approvalType: 'Rejected' })"
                        :active="submission.submission.status === 'Rejected'"
                    />
                </div>

                <div class="status-badge-wrapper flex my-auto mt-3 md:mt-0 md:ml-auto">
                    <button class="py-1 px-3 rounded-full font-semibold outline outline-2 text-error"
                            @click="showHideApprovalModal({ show: true, approvalType: 'Deleted' })">
                        <div class="flex">
                            <svg viewBox="0 0 16 16" height="16" width="16" xmlns="http://www.w3.org/2000/svg"
                                 class="self-center -ml-1 mr-2">
                                <g xmlns="http://www.w3.org/2000/svg" id="Group_20" data-name="Group 20"
                                   transform="translate(-965.5)">
                                    <g id="Ellipse_3" data-name="Ellipse 3" transform="translate(965.5)" fill="none"
                                       stroke="#ef5959" stroke-width="1.5">
                                        <circle cx="8" cy="8" r="8" stroke="none"></circle>
                                        <circle cx="8" cy="8" r="7.25" fill="none"></circle>
                                    </g>
                                    <path id="Path_17" data-name="Path 17" d="M2.708,0V6"
                                          transform="translate(973.707 3.964) rotate(45)" fill="none" stroke="#ef5959"
                                          stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                    <path id="Path_353" data-name="Path 353" d="M0,6V0"
                                          transform="translate(975.621 10.121) rotate(135)" fill="none" stroke="#ef5959"
                                          stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                </g>
                            </svg>
                            Delete
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <HrComponent class="mb-0" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonStatusComponent from "@adminComponents/buttons/ButtonStatusComponent";
import HrComponent from "@adminComponents/misc/HrComponent";
import AppropriatenessScorePillComponent from "@adminComponents/misc/AppropriatenessScorePillComponent";
import InputComponent from "@adminComponents/inputs/InputComponent";

export default {
    name: "SubmissionStatusComponent",
    components: {
        ButtonStatusComponent,
        HrComponent,
        AppropriatenessScorePillComponent,
        InputComponent,
    },
    data() {
        return {
            customAccountNumber: null,
        };
    },
    computed: {
        ...mapGetters(["submission"]),
        submissionStatus() {
            return this.submission.submission != undefined && this.submission.submission.submitted_at
                ? "Submitted"
                : "In Progress";
        },
    },
    methods: {
        ...mapActions(["doUpdateSubmissionStatus", "showHideApprovalModal", "doUpdateSubmissionUserDetails", "doGetSubmission"]),
        isButtonDisabled(buttonType) {
            // If submission is disabled, then disable Approval buttons
            let submissionStatus = this.submission.submission.status;
            switch (buttonType) {
                case "First Approval":
                    return submissionStatus !== "Under Review";
                case "Second Approval":
                    return submissionStatus !== "First Approval";
                default:
                    return true;
            }
        },
        doUpdateUser() {
            let payload = {
                custom_account_number: this.customAccountNumber,
            };
            this.doUpdateSubmissionUserDetails(payload);
        },
    },
    mounted() {
        this.doGetSubmission(this.$route.params.user).then(response => {
            this.customAccountNumber = response.custom_account_number;
        });
    },
};
</script>
